import { Wallet, Undo2 } from "lucide-react";
import { fmtINR } from "@/lib/documents";
import { PAYMENT_METHODS, REFERENCE_REQUIRED } from "@/components/pms/AdvancePaymentInput";

/** FIX 4 · a credit (over-paid) folio is never closed silently: the cashier refunds now or keeps it as guest credit. */
export function CreditResolutionStep({ credit, value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const needsRef = value.action === "refund" && REFERENCE_REQUIRED.has(value.method);
  return (
    <div className="rounded-lg border border-[#FCD34D] bg-[#FFFBEB] p-4 space-y-3" data-testid="credit-resolution">
      <div className="text-[13px] text-[#78530E] font-semibold">Folio has a credit of <span className="mono" data-testid="credit-amount">{fmtINR(credit)}</span> — decide what to do with it before checkout.</div>
      <div className="grid grid-cols-2 gap-2">
        {[["refund", Undo2, "Refund now", "Return the money to the guest"], ["keep_credit", Wallet, "Keep as guest credit", "Stored on the guest profile for a future stay"]].map(([a, Icon, t, d]) => (
          <button key={a} type="button" onClick={() => set({ action: a })} data-testid={`credit-action-${a}`}
            className={`text-left rounded-md border px-3 py-2 transition-colors ${value.action === a ? "border-[#014751] bg-white" : "border-[#EEF4F5] bg-white/60 hover:bg-white"}`}>
            <div className="flex items-center gap-2 text-[13px] font-semibold text-[#1A2425]"><Icon size={14} />{t}</div>
            <div className="text-[11.5px] text-[#3F5257] mt-0.5">{d}</div>
          </button>
        ))}
      </div>
      {value.action === "refund" && (
        <div className="grid grid-cols-2 gap-2">
          <label className="text-[12px] text-[#3F5257]">Refund method
            <select value={value.method || ""} onChange={(e) => set({ method: e.target.value })} data-testid="credit-refund-method"
              className="mt-1 w-full h-9 rounded-md border border-[#D5E6E8] bg-white px-2 text-[13px]">
              <option value="">Select…</option>
              {PAYMENT_METHODS.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
            </select>
          </label>
          <label className="text-[12px] text-[#3F5257]">Reference{needsRef ? " *" : ""}
            <input value={value.reference || ""} onChange={(e) => set({ reference: e.target.value })} placeholder="TXN / UTR" data-testid="credit-refund-reference"
              className="mt-1 w-full h-9 rounded-md border border-[#D5E6E8] bg-white px-2 text-[13px]" />
          </label>
        </div>
      )}
    </div>
  );
}
